module.exports = __webpack_public_path__ + "assets/img/text.9f6aebaa.png";